import { ModelBase } from "@shoothill/core";
import { IsEmail, IsNotEmpty, ValidateIf } from "class-validator";
import { action, computed, observable } from "mobx";

import { InductionType } from "Globals/Models/Enums/InductionType";

export class LandingModel extends ModelBase<LandingModel> {
    // #region Defaults

    public static readonly DEFAULT_AGE = 0;
    public static readonly DEFAULT_INDUCTIONTYPEID = null;
    public static readonly DEFAULT_INDUCTIONTYPES = [];

    // #endregion Defaults

    // #region Properties

    public id: string = "";

    @observable
    public inductionTypes = observable<InductionType>(LandingModel.DEFAULT_INDUCTIONTYPES);

    @observable
    public otherEmployerName: boolean = false;

    @observable
    @ValidateIf((o) => o.isWorker)
    @IsNotEmpty({ message: "You must enter your Priority Employee name" })
    public priorityEmployerName: string = "";

    @observable
    @IsNotEmpty({ message: "You must enter your first name" })
    public firstName: string = "";

    @observable
    @IsNotEmpty({ message: "You must enter your last name" })
    public lastName: string = "";

    @observable
    @IsNotEmpty({ message: "You must enter your email address" })
    @IsEmail({}, { message: "Email is not valid" })
    public emailAddress: string = "";

    @observable
    @IsNotEmpty({ message: "You must select an induction type" })
    public inductionTypeId: string | null = LandingModel.DEFAULT_INDUCTIONTYPEID;

    @observable
    @IsNotEmpty({ message: "You must select your inductee type" })
    public visitorType: string = "";

    @observable
    @ValidateIf((o) => !o.otherEmployerName && o.isWorker)
    @IsNotEmpty({ message: "You must select a supplier" })
    public supplierId: string = "";

    @observable
    @ValidateIf((o) => !o.preferNotToSay)
    @IsNotEmpty({ message: "You must select your age" })
    public age: number = LandingModel.DEFAULT_AGE;

    @observable
    public preferNotToSay: boolean = false;

    @observable
    public visitorTypeType: number | null = null;

    @computed
    public get isWorker() {
        if (this.visitorTypeType === null || this.visitorTypeType === undefined) {
            return false;
        }

        if (this.visitorTypeType === 10 || this.visitorTypeType === 20) {
            return false;
        }

        return true;
    }

    @computed
    public get isDGL() {
        if (this.visitorTypeType === null || this.visitorTypeType === undefined) {
            return false;
        }

        if (this.visitorTypeType === 20) {
            return true;
        }

        return false;
    }

    @computed
    public get isWorkerOrDGL() {
        return this.isWorker;
    }

    @computed
    public get isInductionTypeLocked() {
        if (this.visitorTypeType === null || this.visitorTypeType === undefined) {
            return false;
        }

        if (this.visitorTypeType === 30 || this.visitorTypeType === 40 || this.visitorTypeType === 50 || this.visitorTypeType === 60) {
            return true;
        }

        return false;
    }

    // #endregion Properties

    constructor() {
        super();
    }

    // #region Actions

    @action
    public fromDto(dto: any): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): any {
        return {
            id: this.id,
            priorityEmployerName: this.priorityEmployerName,
            supplierId: this.supplierId,
            firstName: this.firstName,
            lastName: this.lastName,
            emailAddress: this.emailAddress,
            age: this.age,
            visitorType: this.visitorType,
            inductionTypeId: this.inductionTypeId,
        };
    }

    // #endregion Actions
}
